import { Component, Input, OnInit } from "@angular/core";
import { Form, FormControl, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-chip-input",
  templateUrl: "./chip-input.component.html",
  styleUrls: ["./chip-input.component.scss"],
})
export class ChipInputComponent implements OnInit {
  @Input()
  values: string[];
  @Input()
  name: string;
  @Input()
  type: 'text' | 'email';
  value = '';
  emailPrepend = '@state.mn.us'

  constructor() {}

  ngOnInit(): void {
  }

  add() {
    let val = `${this.value}`;
    val = val.trim().toLowerCase();
    if (val) {
      if (this.type === 'email') {
        if (!val.includes('@')) {
          val = val + this.emailPrepend;
        }
      }
      this.values.push(val);
      this.value = '';
    }
  }
}
